<h3>{{ 'change_agent_number.receive_call_on' | translate }}</h3>
<div class="pa-1">
  <user-call-reception #userCallReception [agent]="agent" [numberEditable]="true"></user-call-reception>
</div>
